import { createSelector } from 'reselect';

const stateSelector = (state: any) => state['tag'];

export const emptyTagSelector = createSelector(stateSelector, (value) => (value && value.toJS ? value.toJS() : value));
